import React from 'react';
import { AlertTriangle, Download } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { reachSkillsAPI } from '../../../services/reachService';
import { useParams } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export const REACHFeatureGuard: React.FC<Props> = ({ children }) => {
  const { hasFeature } = useAuth();
  const { projectId } = useParams<{ projectId: string }>();

  if (hasFeature('reach')) return <>{children}</>;

  const handleExport = async () => {
    if (!projectId) return;
    try {
      const r = await reachSkillsAPI.downloadConfig(projectId);
      const url = URL.createObjectURL(r.data as Blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'reach-config.md';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Export failed. Please contact your administrator.');
    }
  };

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex items-start gap-3 px-6 py-4 bg-amber-50 border-b border-amber-200">
        <AlertTriangle size={18} className="text-amber-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-amber-800">REACH module disabled</p>
          <p className="text-xs text-amber-700 mt-0.5">
            Your organisation's REACH access has been removed. All data is preserved in read-only mode. Contact your administrator to restore access.
          </p>
        </div>
        {projectId && (
          <button
            onClick={handleExport}
            className="flex-shrink-0 flex items-center gap-1.5 rounded-lg h-8 px-3 bg-amber-100 border border-amber-300 text-amber-800 text-xs font-semibold hover:bg-amber-200 transition-colors"
          >
            <Download size={13} /> Export data
          </button>
        )}
      </div>
      <div className="pointer-events-none opacity-60 flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
};
